/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConsoleNotificationRequest { 
    title: string;
    message: string;
    details?: string;
    loyaltyProgramId: number;
    target?: ConsoleNotificationRequest.TargetEnum;
    scheduledAt?: string;
}
export namespace ConsoleNotificationRequest {
    export type TargetEnum = 'ALL' | 'ACTIVE_30D' | 'INACTIVE';
    export const TargetEnum = {
        All: 'ALL' as TargetEnum,
        Active30D: 'ACTIVE_30D' as TargetEnum,
        Inactive: 'INACTIVE' as TargetEnum
    };
}


